const CartCancelIcon = () => {
  function closeCartBoxHandler() {
    document.getElementById("CartBoxId").classList.remove("CartBoxShow");
    document
    .getElementById("ProductDetailsBoxId")
    .classList.remove("ProductDetailsBoxShow");
    document.getElementById("BackDrop").classList.remove("menuBackDropHandler");


      document.getElementById("LikedBoxId").classList.add("ShowLikedBox");
      document.getElementById("LikedBoxLineId").innerHTML =
      "ÄNGSKORN was added to your shopping bag";
  }
  return (
    <svg
      className="CartCancelIcon"
      onClick={closeCartBoxHandler}
      id="loginCanceIconlId"
      style={{ width: "36px", height: "36px" }}
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
      />
    </svg>
  );
};
export default CartCancelIcon;
